import type { SVGProps } from "react";
export interface MushroomIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MushroomIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MushroomIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.375 10.75c0 .712-.54 1.295-1.233 1.366l.58 5.792a4.746 4.746 0 1 1-9.444 0l.578-5.792a1.374 1.374 0 0 1-1.224-1.225l-.008-.14.008-.141A1.375 1.375 0 0 1 8 9.375l.14.007a1.376 1.376 0 0 1 1.22 1.555c.486.164.812.643.76 1.174l-.602 6.02a2.496 2.496 0 1 0 4.964 0l-.602-6.02L15 12l.355-.037-1.475.148a1.124 1.124 0 0 1 .759-1.175l-.006-.045-.007-.14.007-.141A1.375 1.375 0 0 1 16 9.375l.14.007c.694.07 1.235.656 1.235 1.369Zm2-5.25a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 18 4.125l.141.007A1.376 1.376 0 0 1 19.375 5.5m-6 1a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.234l.14.008c.693.07 1.233.655 1.233 1.367Zm-6-1a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 6 4.125l.141.007A1.375 1.375 0 0 1 7.374 5.5Z"
      />
      <path
        fill={color}
        d="m12.005.875.545.016c2.744.144 5.84 1.26 7.823 3.242l.466.48c1.033 1.107 1.694 2.141 2.148 3.739l.06.243c.54 2.498-1.629 4.53-3.94 4.53H4.893c-2.386 0-4.618-2.166-3.878-4.773.518-1.826 1.307-2.916 2.612-4.22C5.742 2.02 9.125.89 11.995.876zm-.006 2.25c-2.403.014-5.169.988-6.782 2.6-1.125 1.123-1.656 1.891-2.04 3.24-.245.864.487 1.91 1.715 1.91h14.216c1.15 0 1.866-.919 1.749-1.746l-.035-.164c-.383-1.349-.915-2.117-2.04-3.24-1.614-1.612-4.38-2.587-6.783-2.6"
      />
    </svg>
  );
}
